module.exports = __webpack_public_path__ + "img/stroke.671c4871.png";